<template>
	<div>
		<!--  v-bind:style="heightobject" -->
		<div style="z-index: 100; object-fit: cover;background-repeat:no-repeat;background-position:center"
			:style="{backgroundImage: 'url('+backimg+')' }">

			<div style="text-align: center; width: 100%; padding-top: 40px;padding-bottom: 40px;"
				v-bind:style="heightobject">
				<div v-if="title" class="pageitetitle1">{{title}}</div>
				<div v-if="subtitle"
					style="width: 80%;height: 61px;font-size: 14px;line-height: 21px;text-align: center;margin-left: auto;margin-right: auto;"
					:style="subtitlestyle">
					{{subtitle}}
				</div>
				<!-- v-bind:style="slotviewheight" -->
				<div>
					<slot></slot>
				</div>
			</div>
			<!--  v-bind:style="heightobject" -->
			<!-- 	<img v-if="backimg" style="width: 100%;  object-fit: cover;z-index: 100;"
				:src="backimg" /> -->
		</div>
	</div>
</template>

<script>
	export default {
		name: 'adword',
		props: ['title', 'subtitle', 'backimg', 'viewheight', 'slotheight', 'subtitlestyle'],
		data() {
			return {
				heightobject: {
					height: "auto"
				},
				slotviewheight: {
					height: "auto"
				}
			}
		},
		methods: {


		},

		mounted() {
			// if (this.viewheight) {
			// 	this.slotviewheight.height = parseInt(this.viewheight) - 100 + "px"
			// 	this.heightobject.height = this.viewheight + "px"
			// }

			// if (this.slotheight) {
			// 	this.heightobject.height = parseInt(this.slotheight) + 100 + "px"
			// 	this.slotviewheight.height = this.slotheight + "px"
			// }

		}

	}
</script>


<style>
	@media (max-width: 999px) {
		.pageitetitle1 {
			text-align: center;
			font-size: 20px;
			letter-spacing: 3px;
			padding-bottom: 20px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
		}
	}

	@media (min-width: 1000px) {
		.pageitetitle1 {
			text-align: center;
			font-size: 36px;
			letter-spacing: 6px;
			padding-bottom: 30px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
		}
	}
</style>
